import { types } from 'mobx-state-tree'

export const Category = types.model('Category').props({
  full_url: types.string,
  is_archived: types.boolean,
  label: types.string,
})
